import { useFormContext, useWatch } from 'react-hook-form';
import FormCheckbox from 'components/common/forms/FormCheckbox';
import FormAutoHeightTextarea from 'components/common/forms/FormAutoHeightTextarea';
import {
  AllergyStatus,
  AllergyStatusLabel,
  MedicalHistoryChartFields,
} from 'constants/chart/medicalHistoryChart';
import useModal from 'hooks/useModal';

type TProps = {
  isRegister: boolean;
};

const AllergyCheckbox = ({ isRegister }: TProps) => {
  const { openModal } = useModal();

  const { setValue, control } = useFormContext();

  const allergyCheckWatch = useWatch({
    name: MedicalHistoryChartFields.AllergyCheck,
    control,
  });
  const allergyDetailWatch = useWatch({
    name: MedicalHistoryChartFields.AllergyDetail,
    control,
  });

  return (
    <div>
      <div>
        <FormCheckbox
          id={AllergyStatus.Allergy1}
          name={MedicalHistoryChartFields.AllergyCheck}
          text={AllergyStatusLabel[AllergyStatus.Allergy1]}
          value={AllergyStatus.Allergy1}
          labelStyle={{ marginRight: '80px' }}
          multiple={true}
          readOnly={!isRegister}
        />
        <FormCheckbox
          id={AllergyStatus.Allergy2}
          name={MedicalHistoryChartFields.AllergyCheck}
          text={AllergyStatusLabel[AllergyStatus.Allergy2]}
          value={AllergyStatus.Allergy2}
          labelStyle={{ marginRight: '80px' }}
          multiple={true}
          readOnly={!isRegister}
        />
        <FormCheckbox
          id={AllergyStatus.Allergy3}
          name={MedicalHistoryChartFields.AllergyCheck}
          text={AllergyStatusLabel[AllergyStatus.Allergy3]}
          value={AllergyStatus.Allergy3}
          labelStyle={{ marginRight: '80px' }}
          multiple={true}
          readOnly={!isRegister}
        />
        <FormCheckbox
          id={AllergyStatus.Allergy4}
          name={MedicalHistoryChartFields.AllergyCheck}
          text={AllergyStatusLabel[AllergyStatus.Allergy4]}
          value={AllergyStatus.Allergy4}
          labelStyle={{ marginRight: '80px' }}
          multiple={true}
          readOnly={!isRegister}
        />
        <div className="flex">
          <FormCheckbox
            id={AllergyStatus.Allergy5}
            name={MedicalHistoryChartFields.AllergyCheck}
            text={AllergyStatusLabel[AllergyStatus.Allergy5]}
            value={AllergyStatus.Allergy5}
            labelStyle={{ marginRight: '0' }}
            multiple={true}
            readOnly={!isRegister}
            afterChange={() => {
              if (
                allergyCheckWatch?.includes(AllergyStatus.Allergy5) &&
                allergyDetailWatch
              ) {
                openModal({
                  isConfirm: true,
                  title: '작성 중인 내용을 삭제하시겠습니까?',
                  text: '작성 중인 내용이 삭제됩니다.',
                  onCancel: () => {
                    setValue(MedicalHistoryChartFields.AllergyCheck, [
                      ...allergyCheckWatch,
                      AllergyStatus.Allergy5,
                    ]);
                  },
                  onSubmit: () => {
                    setValue(MedicalHistoryChartFields.AllergyDetail, '');
                  },
                });
              }
            }}
          />
          <FormAutoHeightTextarea
            name={MedicalHistoryChartFields.AllergyDetail}
            placeholder="작성:"
            textareaStyle={{ flex: '1' }}
            readOnly={
              !isRegister ||
              !allergyCheckWatch?.includes(AllergyStatus.Allergy5)
            }
          />
        </div>
      </div>
    </div>
  );
};

export default AllergyCheckbox;
